import { PersonaTypeSingleLetter } from '@rabbit/data/types';
import { Modal } from '@rabbit/elements/shared-components';
import {
  CaseflowContext,
  CaseflowInterface,
} from '@rabbit/sage/context/CaseflowContext';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { CFCF_ExternalRepairInvoice } from '@rabbit/bizproc/core';
import AddEditInvoiceFormRepairer from '../../molecules/AddEditInvoiceFormRepairer/AddEditInvoiceFormRepairer';
import AddEditInvoiceFormWarrantor from '../../molecules/AddEditInvoiceFormWarrantor/AddEditInvoiceFormWarrantor';
import { getInvoiceLabels } from '@rabbit/sage/utils/helpers';
import { ExternalRepairInvoiceType } from '@rabbit/bizproc/core';

export type ModalAddEditInvoiceModes =
  | 'add-edit'
  | 'submit'
  | 'repairer-review';
interface ModalAddEditInvoiceProps {
  handleClose: (submitted?: boolean) => void;
  data?: CFCF_ExternalRepairInvoice;
  mode?: ModalAddEditInvoiceModes;
  invoiceType?: ExternalRepairInvoiceType;
}

export default function ModalAddEditInvoice({
  handleClose,
  data,
  mode = 'add-edit',
  invoiceType = ExternalRepairInvoiceType.REPAIR,
}: ModalAddEditInvoiceProps) {
  const { t } = useTranslation();
  const { operatingPersonaSingleKey, caseState } =
    useContext(CaseflowContext) || ({} as CaseflowInterface);

  function getModalTitle() {
    const labels = getInvoiceLabels(caseState);
    if (operatingPersonaSingleKey === PersonaTypeSingleLetter.Repairer) {
      if (mode === 'submit') {
        return t(labels.modalLabels.submit);
      } else if (mode === 'repairer-review') {
        return t(labels.modalLabels.review);
      } else
        return !data ? t(labels.modalLabels.add) : t(labels.modalLabels.edit);
    }

    if (operatingPersonaSingleKey === PersonaTypeSingleLetter.Warrantor) {
      return t('general.reviewInvoice');
    }
  }

  return (
    <Modal
      settings={{
        title: getModalTitle(),
        handleClose,
      }}
      className="max-w-[1024px]"
      kind="generic"
    >
      {operatingPersonaSingleKey === PersonaTypeSingleLetter.Repairer && (
        <AddEditInvoiceFormRepairer
          handleClose={handleClose}
          data={data}
          mode={mode}
          invoiceType={invoiceType}
        />
      )}
      {operatingPersonaSingleKey === PersonaTypeSingleLetter.Warrantor && (
        <AddEditInvoiceFormWarrantor handleClose={handleClose} data={data} />
      )}
    </Modal>
  );
}
